import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import payrollExpenseMappingComponent from './payroll-expense-mapping.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let payrollExpenseMappingModule = angular.module('payrollExpenseMapping', [
  uiRouter,
  modal,
  datepickerPopup,
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('quickbooks-payroll-expense-mapping', {
    parent: 'app',
    url: '/admin/integrations/quickbooks/payroll-expense-mapping',
    data: {
      pageHeader: true,
      pageTitle: 'Quickbooks Payroll Expense Mapping Capability',
      pageDesc: '',
      breadcrumbLink: 'quickbooks',
      breadcrumbText: 'Quickbooks Capabilities'
    },
    template: '<payroll-expense-mapping></payroll-expense-mapping>'
  })

})

.component('payrollExpenseMapping', payrollExpenseMappingComponent);

export default payrollExpenseMappingModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/payroll-expense-mapping/payroll-expense-mapping.js